module.exports = __webpack_public_path__ + "static/media/PWID-T-02.548cfee3.png";